import { extend, configure } from 'vee-validate'
import { required, email, min, max } from 'vee-validate/dist/rules'
import { i18n } from '../assets/i18n/i18n.js'

const dm = (field, values) => {
  values._field_ = i18n.t(`fields.${field}`)
  return i18n.t(`validation.${values._rule_}`, values)
}

configure({
  defaultMessage: dm
})
extend('required', required)
extend('email', email)
extend('min', min)
extend('max', max)
